/**
 * @exports commaSeparateNumber ( Should be deprecated on next major)
 * @since 2.0.0
 */
import { CONVERTER_DEFAULTS } from '../CurrencyConverter/constants';
import { separateNumber } from '../separateNumber';

/**
 * Deprecation method , was converted to generic method separateNumber
 * @param {String|Number} num
 * @returns {String} representing the number with thousands separated by comma
 */
export const commaSeparateNumber = (num) => separateNumber(num, { thousandsSeparator: CONVERTER_DEFAULTS.thousandsSeparator });
